import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

import CsLineIcons from "../../../cs-line-icons";

const VISIBLE_SCROLL_OFFSET = 240;

class ScrollToTopButton extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        };
    }

    componentDidMount() {
        window.addEventListener("scroll", this.onScroll, { passive: true });
        this.onScroll();
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.onScroll);
    }

    onScroll = () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        const visible = scrollTop > VISIBLE_SCROLL_OFFSET;

        if (this.state.visible !== visible) {
            this.setState({ visible });
        }
    };

    onClick = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    render() {
        if (!this.state.visible) return null;

        return (
            <OverlayTrigger
                delay={{ show: 10, hide: 0 }}
                overlay={<Tooltip>Back to top</Tooltip>}
                placement="left"
            >
                <Button
                    type="button"
                    variant="primary"
                    className="rounded-circle shadow"
                    aria-label="Back to top"
                    onClick={this.onClick}
                    style={{
                        position: "fixed",
                        right: "1.5rem",
                        bottom: "1.5rem",
                        width: "44px",
                        height: "44px",
                        padding: 0,
                        zIndex: 1040,
                    }}
                >
                    <CsLineIcons icon="arrow-top" />
                </Button>
            </OverlayTrigger>
        );
    }
}

export default ScrollToTopButton;
